/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  ProductDraftsUserControllerFindOneQueryResponse,
  ProductDraftsUserControllerFindOnePathParams,
  ProductDraftsUserControllerFindOne401,
  ProductDraftsUserControllerFindOne404,
} from '../../types/ProductDraftsUserControllerFindOne.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { productDraftsUserFindOne } from '../../methods/productDraftsUserFindOne.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const productDraftsUserFindOneQueryKey = (id: ProductDraftsUserControllerFindOnePathParams['id']) =>
  [{ url: '/api/user/product-drafts/:id', params: { id: id } }] as const;

export type ProductDraftsUserFindOneQueryKey = ReturnType<typeof productDraftsUserFindOneQueryKey>;

export function productDraftsUserFindOneQueryOptions(
  id: ProductDraftsUserControllerFindOnePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = productDraftsUserFindOneQueryKey(id);
  return queryOptions<
    ProductDraftsUserControllerFindOneQueryResponse,
    ResponseErrorConfig<ProductDraftsUserControllerFindOne401 | ProductDraftsUserControllerFindOne404>,
    ProductDraftsUserControllerFindOneQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return productDraftsUserFindOne(id, config);
    },
  });
}

/**
 * {@link /api/user/product-drafts/:id}
 */
export function useProductDraftsUserFindOne<
  TData = ProductDraftsUserControllerFindOneQueryResponse,
  TQueryData = ProductDraftsUserControllerFindOneQueryResponse,
  TQueryKey extends QueryKey = ProductDraftsUserFindOneQueryKey,
>(
  id: ProductDraftsUserControllerFindOnePathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ProductDraftsUserControllerFindOneQueryResponse,
        ResponseErrorConfig<ProductDraftsUserControllerFindOne401 | ProductDraftsUserControllerFindOne404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? productDraftsUserFindOneQueryKey(id);

  const query = useQuery(
    {
      ...productDraftsUserFindOneQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<ProductDraftsUserControllerFindOne401 | ProductDraftsUserControllerFindOne404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
